import { render } from "./SubSuccessNot.vue?vue&type=template&id=5f9ec826"
import script from "./SubSuccessNot.vue?vue&type=script&lang=js"
export * from "./SubSuccessNot.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__